import { call, put } from 'redux-saga/effects'
import CouponActions from '../Redux/CouponRedux'
import LoginActions from '../Redux/LoginRedux'
export function * couponList (api, { params }) {
  try {
    const res = yield call(api, params)
    if (res && res.message === 'Unauthenticated.') {
      yield put(LoginActions.loginFailure())
      return
    }
    if (res.success) {
      yield put(CouponActions.couponListSuccess(res.data))
    } else {
      yield put(CouponActions.couponListFailure(res.message))
    }
  } catch (error) {
    yield put(CouponActions.couponListFailure(error.message))
  }
}
